import { WalletCard } from '@givebacks/api/backer';

import { AccountCardPage } from '../components/AccountCardPage/AccountCardPage';

const filterEventCards = (data: WalletCard[]) => data.filter((card) => Boolean(card.event));
const getEventKey = (card: WalletCard) => card.event?.uuid;

const TicketPage = () => {
  return (
    <AccountCardPage
      title="Event Tickets"
      filterFn={filterEventCards}
      getKey={getEventKey}
      noDataMessage={{
        title: "You don't have any tickets yet.",
        message:
          "Browse your organization's page to purchase tickets for upcoming events, and you'll see them here.",
      }}
    />
  );
};

export { TicketPage as AccountTicketsPage };
